<template>
  <view
    class="decision-icon"
    :class="[`is-${type}`]"
    :style="iconStyle"
    aria-hidden="true"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    /** yes = 勾，no = 叉 */
    type: 'yes' | 'no';
    /** 图标颜色，默认 yes=#171b24 / no=#ffffff */
    color?: string;
    /** 边长，支持 number(rpx) 或带单位字符串 */
    size?: number | string;
  }>(),
  {
    color: undefined,
    size: 28,
  }
);

const iconStyle = computed(() => {
  const size =
    typeof props.size === 'number' ? `${props.size}rpx` : props.size || '28rpx';
  const color =
    props.color || (props.type === 'yes' ? '#171b24' : '#ffffff');
  return {
    width: size,
    height: size,
    color,
  };
});
</script>

<style lang="scss" scoped>
.decision-icon {
  display: inline-block;
  flex-shrink: 0;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;

  &.is-yes {
    -webkit-mask-image: url('/static/image/decision/yes-check.webp');
    mask-image: url('/static/image/decision/yes-check.webp');
  }

  &.is-no {
    -webkit-mask-image: url('/static/image/decision/no-x.webp');
    mask-image: url('/static/image/decision/no-x.webp');
  }
}
</style>
